





import {Component, Vue} from 'vue-property-decorator';
import {isMobile} from '@/utils/helpers';
import _ from 'lodash';

@Component({
  name: 'ImageCTAHeader',
})
export default class ImageCTAHeader extends Vue {
  private slides: HTMLElement[] = [];
  private tabs: HTMLElement[] = [];
  private ctasContainer: HTMLElement | null = null;

  private debouncedCalculatePadding = _.debounce(() => this.calculatePadding(), 200);

  mounted() {
    const root = this.$el.querySelector<HTMLElement>('.image-cta-header');
    if (!root) {
      return;
    }

    this.slides = Array.from(root.querySelectorAll<HTMLElement>('.bg-swiper > .swiper-slide'));
    this.tabs = Array.from(root.querySelectorAll<HTMLElement>('.image-cta-header__ctas > .tab'));
    this.ctasContainer = root.querySelector<HTMLElement>('.image-cta-header__ctas');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => this.switchSlide(index));
    });

    window.addEventListener('resize', this.debouncedCalculatePadding);
    this.calculatePadding();

    if (isMobile && this.slides.length > 1) {
      this.switchSlide(Math.floor(Math.random() * this.slides.length));
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedCalculatePadding);
  }

  private switchSlide(index: number) {
    this.slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
    this.tabs.forEach((tab, i) => tab.classList.toggle('active', i === index));
  }

  private calculatePadding() {
    if (!this.ctasContainer) {
      return;
    }

    const padding = window.matchMedia('(max-width: 1024px)').matches
        ? '0px'
        : `calc(${this.ctasContainer.clientHeight}px + 2rem)`;

    (this.$el as HTMLElement).style.setProperty('--cta-bottom-padding', padding);
  }
}
